const MyServices = () => {
  return (
    <div className="page-title">
      <h1>My Services</h1>
    </div>
  );
};

export default MyServices;
